import styled, { css } from 'styled-components';
export const radioWrapperStyles = () => css `
	label {
		display: flex;
	}
`;
export const RadioWrapper = styled.div `
	${radioWrapperStyles}
`;
